(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('SearchDialogController', SearchDialogController);

	SearchDialogController.$inject = ['$scope', '$mdDialog', 'systemPouch', '$mdMedia', 'WineTable', '$log', 'lodash', '$state', '$filter', 'WineRepository', 'ENV', 'Utils'];

	function SearchDialogController($scope, $mdDialog, systemPouch, $mdMedia, WineTable, $log, lodash, $state, $filter, WineRepository, ENV, Utils){

		/* jshint validthis: true */
		var self = this;

		self.screenIsSmall = $mdMedia('sm');

		/**
		 * Structure maps to the WineTable adv query object
		 */
		self.query = {};
		self.bodyOptions = [
			{
				value: "Light",
				display: "Light"
			},
			{
				value: "Medium",
				display: "Medium"
			},
			{
				value: "Full",
				display: "Full"
			}
		];
		self.bottleSizes = [];
		self.maturities = [];

		self.varietals = [];
		self.distinctions = [];

		self.resetSearch = resetSearch;
		self.searchIsDirty = searchIsDirty;
		self.close = close;
		self.search = search;
		self.varietalSearch = varietalSearch;
		self.distinctionSearch = distinctionSearch;
        self.selectedDistinction = selectedDistinction;
		self.localeSymbol = ENV.LOCALE_SYMBOL;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			self.query = WineTable.advQuery;

			systemPouch.fetch('category')
				.then(function(data){
					self.categories = data;
				});

			// get unique bottle sizes from User's collection

			self.bottleSizes = lodash.unique(lodash.pluck(WineTable.wines, 'bottleSize.name')).sort();

			// get unique maturities from User's collection

			self.maturities = lodash.unique(lodash.pluck(WineTable.wines, 'cellar.aging.maturity')).sort();

			lodash.remove(self.bottleSizes, lodash.isEmpty);
			lodash.remove(self.maturities, lodash.isEmpty);

            WineRepository.uniqueVarietals().then(function(varietals){
            	self.varietals = varietals;
			});

            systemPouch.fetch('distinction').then(function(data){
                self.distinctions = data;
            });
		}

		function resetSearch(){
			WineTable.resetAdvSearch();
		}

		function searchIsDirty(){
			return WineTable.isAdvSearch();
		}

		function search(){

			WineTable.setAdvQuery(self.query);

			close().then(function(){
				if ($state.current.name != 'wines'){
					Utils.go('wines');
				}
			});
		}

		function close(){
			return $mdDialog.hide();
		}

        function varietalSearch(query) {
            return querySearch(self.varietals, query);
        }

        function distinctionSearch(query){
            return querySearch(self.distinctions, query, 'name');
        }

        function querySearch(collection, query, itemProp) {

            var results = lodash.isNotEmptyOrNull(collection) && query && query.length > 0 ? collection.filter(createFilterFor(query, itemProp)) : collection;

            return results;
        }

        function createFilterFor(query, itemProp) {

            var needle = lodash.words(angular.$$lowercase(query)).join(' ');

            return function filterFn(item) {
                var haystack = angular.$$lowercase(itemProp ? item[itemProp] : item);
                var silencedDiacritics = $filter('diacriticsFilterFunction')(haystack);
                return lodash.contains(haystack, needle) ||
                    lodash.contains(haystack.replace(/-/g, ' '), needle) ||
                    lodash.contains(silencedDiacritics, needle) ||
                    lodash.contains(silencedDiacritics.replace(/-/g, ' '), needle);
            };
        }

        function selectedDistinction(item){
            if (lodash.isNotEmptyOrNull(item)) {
                $log.debug('User chose a distinction', item);
                lodash.set(self.query, 'distinctionName.val', item.name);
                // mark valid
                _getDistinctionInput().$setValidity("require-match", true);
            }
        }

        function _getForm(){
        	return $scope.advancedSearch;
		}

        function _getDistinctionInput(){
        	return _getForm().wineDistinction;
		}
	}

})();
